import React from 'react';
import { Box, Divider } from '@mui/material';
import { useTicketsSelected } from '@/store';
import TicketSummary from '../tickets/TicketSummary';
import BackButton from '../../components/BackButton';
import BookingSummary from './BookingSummary';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';

export default function EventTickets({ onBack = () => {} }) {
  const { hasTickets } = useTicketsSelected();
  const { clickedOnBackButton } = useAnalyticsEvents();
  const onBackHandler = () => {
    onBack();
    clickedOnBackButton();
  };
  return (
    <Box>
      <BackButton onClick={onBackHandler} />
      <Box
        sx={{
          mr: '24px',
          ml: '24px',
        }}
      >
        <TicketSummary />
      </Box>
      <Divider sx={{ mt: 2 }} />
      <Box
        sx={{
          mr: '24px',
          ml: '24px',
        }}
      >
        <BookingSummary changeView={onBackHandler} />
      </Box>
      {hasTickets && (
        <Box
          sx={{
            height: '100px',
            width: '100%',
          }}
        ></Box>
      )}
    </Box>
  );
}
